import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';
import {
  Add as AddIcon,
  AccountTree as WorkflowIcon,
} from '@mui/icons-material';
import type { CreateWorkflowDialogProps, WorkflowSchrittDto } from './types';
import { WORKFLOW_KATEGORIEN } from './utils';
import WorkflowStepEditor from './WorkflowStepEditor';

const CreateWorkflowDialog: React.FC<CreateWorkflowDialogProps> = ({
  open,
  onClose,
  formData,
  onFormChange,
  onAddStep,
  onRemoveStep,
  onStepChange,
  onCreate,
  isCreating,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <WorkflowIcon color="primary" />
          Neuen Workflow erstellen
        </Box>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Workflow-Name"
              value={formData.name}
              onChange={(e) => onFormChange({ ...formData, name: e.target.value })}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth required>
              <InputLabel>Kategorie</InputLabel>
              <Select
                value={formData.kategorie}
                onChange={(e) => onFormChange({ ...formData, kategorie: e.target.value })}
                label="Kategorie"
              >
                {WORKFLOW_KATEGORIEN.map((kat) => (
                  <MenuItem key={kat} value={kat}>{kat}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={2}
              label="Beschreibung (optional)"
              value={formData.beschreibung}
              onChange={(e) => onFormChange({ ...formData, beschreibung: e.target.value })}
            />
          </Grid>
        </Grid>

        <Typography variant="h6" sx={{ mt: 3, mb: 2 }}>
          Workflow-Schritte
        </Typography>

        {formData.schritte.map((schritt, index) => (
          <WorkflowStepEditor
            key={index}
            schritt={schritt}
            index={index}
            canRemove={formData.schritte.length > 1}
            onRemove={onRemoveStep}
            onChange={(idx, field, value) => onStepChange(idx, field as keyof WorkflowSchrittDto, value as string)}
          />
        ))}

        <Button startIcon={<AddIcon />} onClick={onAddStep} variant="outlined" fullWidth>
          Schritt hinzufügen
        </Button>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Abbrechen</Button>
        <Button
          variant="contained"
          onClick={onCreate}
          disabled={isCreating}
          startIcon={isCreating ? <CircularProgress size={16} /> : <WorkflowIcon />}
        >
          {isCreating ? 'Erstellt...' : 'Workflow erstellen'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateWorkflowDialog;
